// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skill-container {
  width: 100%;
  position: absolute;
  z-index: 100;
  align-self: center;
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.skill-container .skymp-button {
  transition: transform 200ms;
}
.skill-container .skymp-button:not(.disabled):hover {
  transform: scale(1.125);
}

.perks {
  font-size: 32px;
  color: rgba(157, 158, 158, 0.75);
  transform-origin: top;
  position: relative;
}
.perks__content {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  width: 1720px;
  height: 980px;
  padding: 0 32px;
}
.perks__header {
  margin: 28px auto auto;
  display: flex;
  justify-content: space-between;
  width: 90%;
}
.perks__list-container {
  height: 100%;
}
.perks__list {
  padding: 28px 0;
  display: flex;
  gap: 74px;
}
.perks__category {
  display: flex;
  position: relative;
  height: fit-content;
  width: 272px;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 32px;
  z-index: 10;
}
.perks__perk {
  width: 128px;
  height: 128px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  border-radius: 32px;
  border: 6px rgb(157, 158, 158) solid;
  color: rgb(157, 158, 158);
  transition: color 200ms, border-color 200ms, opacity 200ms, transform 200ms;
  opacity: 0.75;
}
.perks__perk__icon {
  position: relative;
  bottom: -12px;
  height: 70px;
}
.perks__perk__icon svg {
  fill: rgb(157, 158, 158);
}
.perks__perk__price {
  position: relative;
  bottom: -4px;
  gap: 4px;
  display: flex;
  align-items: center;
}
.perks__perk:hover {
  opacity: 0.75;
  transform: scale(1.125);
  cursor: pointer;
}
.perks__perk:focus {
  scale: 1;
}
.perks__perk--absolute {
  position: absolute;
  bottom: -160px;
}
.perks__perk--left {
  left: 0;
}
.perks__perk--right {
  right: 0;
}
.perks__perk--level-0 {
  opacity: 0.35;
}
.perks__perk--level-0:focus {
  opacity: 0.75;
  color: #7175d6;
  border-color: #7175d6;
}
.perks__perk--level-0:focus svg {
  fill: #7175d6;
}
.perks__perk--level-0:focus .perks__exp {
  background-color: #7175d6;
}
.perks__perk--level-0.perks__perk--short:focus {
  color: #5dad60;
  border-color: #5dad60;
}
.perks__perk--level-0.perks__perk--short:focus svg {
  fill: #5dad60;
}
.perks__perk--level-0.perks__perk--short:focus .perks__exp {
  background-color: #5dad60;
}
.perks__perk--level-1 {
  color: #7175d6;
  border-color: #7175d6;
}
.perks__perk--level-1 svg {
  fill: #7175d6;
}
.perks__perk--level-1 .perks__exp {
  background-color: #7175d6;
}
.perks__perk--level-1:focus {
  color: #5dad60;
  border-color: #5dad60;
}
.perks__perk--level-1:focus svg {
  fill: #5dad60;
}
.perks__perk--level-1:focus .perks__exp {
  background-color: #5dad60;
}
.perks__perk--level-2 {
  color: #5dad60;
  border-color: #5dad60;
}
.perks__perk--level-2 svg {
  fill: #5dad60;
}
.perks__perk--level-2 .perks__exp {
  background-color: #5dad60;
}
.perks__perk--level-2:focus {
  color: #c5d321;
  border-color: #c5d321;
}
.perks__perk--level-2:focus svg {
  fill: #c5d321;
}
.perks__perk--level-2:focus .perks__exp {
  background-color: #c5d321;
}
.perks__perk--level-2.perks__perk--short:focus {
  color: #a062c9;
  border-color: #a062c9;
}
.perks__perk--level-2.perks__perk--short:focus svg {
  fill: #a062c9;
}
.perks__perk--level-2.perks__perk--short:focus .perks__exp {
  background-color: #a062c9;
}
.perks__perk--level-3 {
  color: #c5d321;
  border-color: #c5d321;
}
.perks__perk--level-3 svg {
  fill: #c5d321;
}
.perks__perk--level-3 .perks__exp {
  background-color: #c5d321;
}
.perks__perk--level-3:focus {
  color: #a062c9;
  border-color: #a062c9;
}
.perks__perk--level-3:focus svg {
  fill: #a062c9;
}
.perks__perk--level-3:focus .perks__exp {
  background-color: #a062c9;
}
.perks__perk--level-4 {
  color: #a062c9;
  border-color: #a062c9;
}
.perks__perk--level-4 svg {
  fill: #a062c9;
}
.perks__perk--level-4 .perks__exp {
  background-color: #a062c9;
}
.perks__exp-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}
.perks__exp-container__line {
  display: flex;
  position: relative;
  gap: 18px;
}
.perks__exp-container__line__price {
  display: flex;
  gap: 7px;
  align-items: center;
}
.perks__exp {
  border-radius: 50%;
  background-color: rgb(157, 158, 158);
  width: 16px;
  height: 16px;
  display: inline-block;
}
.perks__footer {
  display: flex;
  padding: 0 6px 24px;
  min-height: 245px;
  position: relative;
}
.perks__footer__description {
  width: 60%;
  padding-right: 24px;
}
.perks__footer__description__text {
  margin-top: 17px;
}
.perks__footer__buttons {
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.perks__footer__buttons__confirm {
  display: flex;
  gap: 11px;
}
.perks__footer__exit-button {
  justify-content: center;
  display: flex;
  align-items: end;
  width: 20%;
  bottom: 24px;
  right: 0;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/features/testMenu/styles.scss"],"names":[],"mappings":"AAYA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAXF;AAaE;EACE,2BAAA;AAXJ;AAaE;EACE,uBAAA;AAXJ;;AAeA;EACE,eAAA;EACA,gCA5BW;EA6BX,qBAAA;EACA,kBAAA;AAZF;AAcE;EACE,yDAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;AAZJ;AAeE;EACE,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,UAAA;AAbJ;AAgBE;EACE,YAAA;AAdJ;AAiBE;EACE,eAAA;EACA,aAAA;EACA,SAAA;AAfJ;AAkBE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AAhBJ;AAmBE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAhFM;EAiFN,2EAAA;EAEA,aAAA;AAlBJ;AAoBI;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AAlBN;AAmBM;EACE,wBA1FE;AAyEV;AAqBI;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;AAnBN;AAsBI;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AApBN;AAsBI;EACE,QAAA;AApBN;AAwBE;EACE,kBAAA;EACA,cAAA;AAtBJ;AAyBE;EACE,OAAA;AAvBJ;AA0BE;EACE,QAAA;AAxBJ;AA2BE;EACE,aAAA;AAzBJ;AA0BI;EACE,aAAA;EACA,cA/HI;EAgIJ,qBAhII;AAwGV;AAyBM;EACE,aAlIE;AA2GV;AAyBM;EACE,yBArIE;AA8GV;AA2BM;EACE,cAzIE;EA0IF,qBA1IE;AAiHV;AA0BQ;EACE,aA5IA;AAoHV;AA0BQ;EACE,yBA/IA;AAuHV;AA8BE;EACE,cAvJM;EAwJN,qBAxJM;AA4HV;AA6BI;EACE,aA1JI;AA+HV;AA6BI;EACE,yBA7JI;AAkIV;AA6BI;EACE,cA/JI;EAgKJ,qBAhKI;AAqIV;AA4BM;EACE,aAlKE;AAwIV;AA4BM;EACE,yBArKE;AA2IV;AA+BE;EACE,cA3KM;EA4KN,qBA5KM;AA+IV;AA8BI;EACE,aA9KI;AAkJV;AA8BI;EACE,yBAjLI;AAqJV;AA8BI;EACE,cAnLI;EAoLJ,qBApLI;AAwJV;AA6BM;EACE,aAtLE;AA2JV;AA6BM;EACE,yBAzLE;AA8JV;AA+BM;EACE,cA7LE;EA8LF,qBA9LE;AAiKV;AA8BQ;EACE,aAhMA;AAoKV;AA8BQ;EACE,yBAnMA;AAuKV;AAkCE;EACE,cA3MM;EA4MN,qBA5MM;AA4KV;AAiCI;EACE,aA9MI;AA+KV;AAiCI;EACE,yBAjNI;AAkLV;AAiCI;EACE,cAnNI;EAoNJ,qBApNI;AAqLV;AAgCM;EACE,aAtNE;AAwLV;AAgCM;EACE,yBAzNE;AA2LV;AAmCE;EACE,cA/NM;EAgON,qBAhOM;AA+LV;AAkCI;EACE,aAlOI;AAkMV;AAkCI;EACE,yBArOI;AAqMV;AAoCE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAlCJ;AAoCI;EACE,aAAA;EACA,kBAAA;EACA,SAAA;AAlCN;AAoCM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAlCR;AAuCE;EACE,kBAAA;EACA,oCApQM;EAqQN,WAAA;EACA,YAAA;EACA,qBAAA;AArCJ;AAwCE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAtCJ;AAwCI;EACE,UAAA;EACA,mBAAA;AAtCN;AAuCM;EACE,gBAAA;AArCR;AAwCI;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AAtCN;AAuCM;EACE,aAAA;EACA,SAAA;AArCR;AAwCI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;AAtCN","sourcesContent":["// Legacy skill-tree test harness: fixed 1720x980 canvas scaled to fit. Only the\n// typeface was aligned with the rest of the UI; the perk tile colours encode\n// skill levels (data), so they stay as they are.\n$level-0: rgb(157, 158, 158);\n$font-color: rgba(157, 158, 158, 0.75);\n$level-1: #7175d6;\n$level-2: #5dad60;\n$level-3: #c5d321;\n$level-4: #a062c9;\n\n$regular: 200ms;\n\n.skill-container {\n  width: 100%;\n  position: absolute;\n  z-index: 100;\n  align-self: center;\n  justify-self: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .skymp-button {\n    transition: transform $regular;\n  }\n  .skymp-button:not(.disabled):hover {\n    transform: scale(1.125);\n  }\n}\n\n.perks {\n  font-size: 32px;\n  color: $font-color;\n  transform-origin: top;\n  position: relative;\n\n  &__content {\n    font-family: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n    display: flex;\n    flex-direction: column;\n    z-index: 9999;\n    width: 1720px;\n    height: 980px;\n    padding: 0 32px;\n  }\n\n  &__header {\n    margin: 28px auto auto;\n    display: flex;\n    justify-content: space-between;\n    width: 90%;\n  }\n\n  &__list-container {\n    height: 100%;\n  }\n\n  &__list {\n    padding: 28px 0;\n    display: flex;\n    gap: 74px;\n  }\n\n  &__category {\n    display: flex;\n    position: relative;\n    height: fit-content;\n    width: 272px;\n    flex-wrap: wrap;\n    column-gap: 16px;\n    row-gap: 32px;\n    z-index: 10;\n  }\n\n  &__perk {\n    width: 128px;\n    height: 128px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    border-radius: 32px;\n    border: 6px $level-0 solid;\n    color: $level-0;\n    transition: color $regular, border-color $regular, opacity $regular,\n      transform $regular;\n    opacity: 0.75;\n\n    &__icon {\n      position: relative;\n      bottom: -12px;\n      height: 70px;\n      svg {\n        fill: $level-0;\n      }\n    }\n\n    &__price {\n      position: relative;\n      bottom: -4px;\n      gap: 4px;\n      display: flex;\n      align-items: center;\n    }\n\n    &:hover {\n      opacity: 0.75;\n      transform: scale(1.125);\n      cursor: pointer;\n    }\n    &:focus {\n      scale: 1;\n    }\n  }\n\n  &__perk--absolute {\n    position: absolute;\n    bottom: -160px;\n  }\n\n  &__perk--left {\n    left: 0;\n  }\n\n  &__perk--right {\n    right: 0;\n  }\n\n  &__perk--level-0 {\n    opacity: 0.35;\n    &:focus {\n      opacity: 0.75;\n      color: $level-1;\n      border-color: $level-1;\n      svg {\n        fill: $level-1;\n      }\n      .perks__exp {\n        background-color: $level-1;\n      }\n    }\n    &.perks__perk--short {\n      &:focus {\n        color: $level-2;\n        border-color: $level-2;\n        svg {\n          fill: $level-2;\n        }\n        .perks__exp {\n          background-color: $level-2;\n        }\n      }\n    }\n  }\n\n  &__perk--level-1 {\n    color: $level-1;\n    border-color: $level-1;\n    svg {\n      fill: $level-1;\n    }\n    .perks__exp {\n      background-color: $level-1;\n    }\n    &:focus {\n      color: $level-2;\n      border-color: $level-2;\n      svg {\n        fill: $level-2;\n      }\n      .perks__exp {\n        background-color: $level-2;\n      }\n    }\n  }\n\n  &__perk--level-2 {\n    color: $level-2;\n    border-color: $level-2;\n    svg {\n      fill: $level-2;\n    }\n    .perks__exp {\n      background-color: $level-2;\n    }\n    &:focus {\n      color: $level-3;\n      border-color: $level-3;\n      svg {\n        fill: $level-3;\n      }\n      .perks__exp {\n        background-color: $level-3;\n      }\n    }\n    &.perks__perk--short {\n      &:focus {\n        color: $level-4;\n        border-color: $level-4;\n        svg {\n          fill: $level-4;\n        }\n        .perks__exp {\n          background-color: $level-4;\n        }\n      }\n    }\n  }\n\n  &__perk--level-3 {\n    color: $level-3;\n    border-color: $level-3;\n    svg {\n      fill: $level-3;\n    }\n    .perks__exp {\n      background-color: $level-3;\n    }\n    &:focus {\n      color: $level-4;\n      border-color: $level-4;\n      svg {\n        fill: $level-4;\n      }\n      .perks__exp {\n        background-color: $level-4;\n      }\n    }\n  }\n\n  &__perk--level-4 {\n    color: $level-4;\n    border-color: $level-4;\n    svg {\n      fill: $level-4;\n    }\n    .perks__exp {\n      background-color: $level-4;\n    }\n  }\n\n  &__exp-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 8px;\n\n    &__line {\n      display: flex;\n      position: relative;\n      gap: 18px;\n\n      &__price {\n        display: flex;\n        gap: 7px;\n        align-items: center;\n      }\n    }\n  }\n\n  &__exp {\n    border-radius: 50%;\n    background-color: $level-0;\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n  }\n\n  &__footer {\n    display: flex;\n    padding: 0 6px 24px;\n    min-height: 245px;\n    position: relative;\n\n    &__description {\n      width: 60%;\n      padding-right: 24px;\n      &__text {\n        margin-top: 17px;\n      }\n    }\n    &__buttons {\n      width: 20%;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      align-items: center;\n      &__confirm {\n        display: flex;\n        gap: 11px;\n      }\n    }\n    &__exit-button {\n      justify-content: center;\n      display: flex;\n      align-items: end;\n      width: 20%;\n      bottom: 24px;\n      right: 0;\n      position: absolute;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
